import styled from 'foundations-theming/utils';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const getHoverCssStyles = theme => {
  return {
    cursor: 'pointer',
    '&:hover h6': {
      color: theme.color['text-interactive-default-hover']
    }
  };
};
const StyledWrapper = styled.div.withConfig({
  displayName: "FieldGroupWrapper__StyledWrapper"
})(({
  theme,
  $cssStyles,
  $highlightOnHover
}) => {
  return Object.assign({}, $cssStyles, $highlightOnHover ? getHoverCssStyles(theme) : {}, {
    'div:nth-child(1) > div:nth-child(1) > &:nth-child(1)': {
      borderTop: 'none'
    },
    '& + [data-is-group]': {
      borderTop: 'none'
    },
    '+ [data-field-key]:not([data-is-group])': {
      marginTop: theme.space['400']
    },
    '[data-field-key]:not([data-is-group]) + &': {
      marginTop: theme.space['700']
    },
    '[data-field-key]:not([data-is-group]):has([data-is-group]) + &': {
      borderTop: 'none',
      marginTop: theme.space['0']
    }
  });
});
export const FieldGroupWrapper = props => {
  const {
    onClick,
    stretchToSides,
    highlightOnHover
  } = props;
  const {
    tokenProps,
    domProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(Object.assign({
    borderBlockWidth: '100',
    borderBlockColor: 'border-core-subtle',
    borderBlockStyle: 'solid'
  }, stretchToSides ? {
    marginInline: '-600'
  } : {}, tokenProps));
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(StyledWrapper, Object.assign({
      $cssStyles: cssStyles,
      $highlightOnHover: highlightOnHover,
      "data-is-group": true,
      onClick: onClick
    }, domProps, {
      children: props.children
    }))
  );
};